import axios from "axios";

export const retrieveGrant = async (username, externalReference) => {
    try {
        const {data} = await axios.get("/api/grant/view?username=" + username + "&externalReference=" + externalReference);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllGrants = async (username) => {
    try {
        const {data} = await axios.get("/api/grant/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const createGrant = async (username, grantVOtoCreate) => {
    try {
        const {data} = await axios.post("/api/grant/create", {username, grantVOtoCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateGrant = async (username, grantVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/grant/update", {username, grantVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteGrant = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/grant/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllGrantsForSystemUser = async (username, externalReference) => {
    try {
        const {data} = await axios.post("/api/grant/viewFromSystemUser", {username, externalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
